import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';
import { getKey, clientMessage } from '../../utils/common';
import { PAYMENT_FLOW, PAYMODE, API } from '../../../../common/src/constant';
import CONSTANT, { CACHE } from '../../utils/constants';

import { handlePostData } from '../../utils/formPost';
import { EVENT, log } from '../../common/logger';

class MGV extends Component {
  componentDidMount() {
    if (this.props.mgv) {
      if (this.props.mgv.isEnabled) {
        if (this.props.isMgvBalSufficient) {
          setTimeout(() => {
            log({ eventType: EVENT.SELECTED_PAYMODE, payMode: this.props.mgv.paymentMode });
            if (getKey(this.props.cache.getData(CONSTANT.CURRENT_PAYMODE), 'type') === 'mgv') {
              this.props.onSelectChange(this.props.mgv);
            }
          }, 0);
        } else {
          log({ eventType: EVENT.MGV_BALANCE_INSUFFICIENT });
        }
      }
    }
  }

  handleAfterPay = response => {
    const { callBackUrl, txnInfo } = getKey(response, 'body', undefined);
    response.body.content = txnInfo;
    response.body.callbackUrl = callBackUrl;
    handlePostData(response, this.props.cache);
  };

  submit = () => {
    const payload = this.props.cache.getData(CACHE.API).requestPayload(API.PT);
    const paymentOptions = this.props.cache.getData('paymentOptions');
    let reqData = {
      body: {
        paymentMode: CONSTANT.GIFT_VOUCHER,
        authMode: CONSTANT['3D'],
        paymentFlow: paymentOptions.paymentFlow,
        templateId: this.props.mgv.templateId
      }
    };
    reqData = { ...reqData.body, ...payload.query };
    this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANT.PROCESSING });
    this.props.cache
      .getData(CACHE.API)
      .pay(reqData)
      .then(response => {
        this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
        if (response && getKey(response, 'body.resultInfo.resultStatus') === 'S') {
          this.props.cache.setData(CONSTANT.CURRENT_PAYMODE, this.props.mgv);
          this.handleAfterPay(response);
        }
      })
      .catch(() => {
        this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
      });
  };

  onOptionSelect = option => {
    const paymentOptions = { ...this.props.cache.getData(CACHE.PAYMENT_OPTIONS) };
    const wallet = { ...paymentOptions.wallet, isUsed: false };
    paymentOptions.wallet = wallet;
    paymentOptions.paymentFlow === PAYMENT_FLOW.ADDANDPAY &&
      (paymentOptions.payData = paymentOptions.merchantPayOption);
    this.props.cache.setData(CACHE.PAYMENT_OPTIONS, paymentOptions);
    this.props.onWalletToggle(wallet);
    this.props.onPayDataChange(paymentOptions);
    this.props.onOptionSelect(option);
    this.props.onPayChange(true);
  };

  render({ instanceKey, isMgvActive, mgv, isMgvBalSufficient, cache }) {
    if (!mgv) return null;
    const isMgvDisabled = !(mgv.isEnabled && isMgvBalSufficient);
    const locale = clientMessage(PAYMODE.GIFT_VOUCHER.toLowerCase(), cache);
    this.label = locale.label;
    return (
      <div
        class={`ptm-pay-method ptm-w100-ib ${isMgvDisabled ? 'ptm-disabled-mgv' : ''}`}
        id="checkout-mgv"
        ref={componentRef => {
          this.componentRef = componentRef;
        }}
      >
        <div class={`ptm-radio-wrap ptm-pt11`}>
          <label class="ptm-lbl">
            <input
              type="radio"
              name={`verify${instanceKey}`}
              checked={isMgvActive}
              disabled={isMgvDisabled}
              onClick={() => {
                this.onOptionSelect(mgv);
              }}
            />
            <span class="ptm-checkmark" />
            <div className={`ptm-pay-method-cont`}>
              <p className={`ptm-paymode-name`}>{mgv.displayName}</p>
              <p className={`ptm-small-txt`}>
                Available Balance Rs {mgv.availableBalance ? mgv.availableBalance : 0}
              </p>
              {!isMgvBalSufficient && mgv.isEnabled && (
                <p className={`ptm-small-txt ptm-msg-red`}>{this.label.insufficientBalance}</p>
              )}
              {!mgv.isEnabled && <p className={`ptm-small-txt ptm-msg-red`}>{mgv.disableMsg}</p>}
            </div>
          </label>
        </div>
      </div>
    );
  }
}

export default connect(
  'selected,mgv, cache, instanceKey',
  onChange
)(MGV);



// WEBPACK FOOTER //
// ./components/mgv/index.js